<template>
    <div class="w-full grow flex flex-col">
        <LoungeAirportSearch v-if="searchType === 'Find a lounge'" />
        <LoungeWizardSearch v-if="searchType === 'Trip wizard'" />
    </div>
</template>

<script setup>
import LoungeAirportSearch from '@/components/tools/lounges/lounges-search/lounge-airport-search/lounge-airport-search.vue';
import LoungeWizardSearch from '@/components/tools/lounges/lounge-wizard/lounge-wizard-search/lounge-wizard-search.vue';

const props = defineProps({
    searchType: {
        type: String,
        default: 'Find a lounge',
    },
});
</script>
